module.exports = __webpack_public_path__ + "media/images/flags/16/Namibia-30467b2b392b41a5228e5f65afabcb61.png";